import React from 'react'

import { type Question } from '~/hooks/useSurveyQuery'
import { pathAssume, pathOrWith, QuestionOp } from '~/utils'

import { useNormalAnswersData } from '../hooks/useNormalAnswersData'
import { getAnswerOptionRowId } from '../utils'

import { IndividualTable, type IndividualTableProps } from './IndividualTable'

export type IndividualQuestionTableProps = {
  question: Question
}

export const IndividualQuestionTable = ({
  question,
}: IndividualQuestionTableProps) => {
  const answersData = useNormalAnswersData(question)
  const individualTableProps = React.useMemo<
    IndividualTableProps<(typeof answersData)[number]>
  >(
    () => ({
      getAnswerText: pathAssume('answerOption.text'),
      getLabel: pathOrWith('0.question', QuestionOp.toText, ''),
      getRowId: (answerData) =>
        getAnswerOptionRowId(answerData.question, answerData.answerOption),
      getSubLabel: pathAssume('answerOption.text'),
      id: question.question_id,
      rowsData: answersData,
    }),
    [answersData, question.question_id],
  )

  return <IndividualTable {...individualTableProps} />
}
